
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"stroke-width":"1.6","d":"M9.06 10h-5v10h5l6.88 6.25V3.75L9.06 10z"}}),_c('path',{attrs:{"stroke-width":"1.2","d":"M23 22a9.9 9.9 0 000-14M19.67 20a6.6 6.6 0 000-9.34"}})])])
          )
        }
      }
    